import Mutations from '../../odata/mutations';

export default { ...new Mutations('productFeature'), ...new Mutations('productFeatures') };
